import { useState } from "react"
import { useUnit } from "effector-react"
import { $userService } from "@callcenter/effector-services"
import { StorageService } from "@callcenter/services"

import {
  API_DEPRECATION_DISMISSED_STORAGE_KEY,
  API_DEPRECATION_REQUIRED_PERMISSIONS,
  API_DEPRECATION_DEADLINE
} from "./api-deprecation-banner.constants"

const dismissedStorage = new StorageService<boolean>(API_DEPRECATION_DISMISSED_STORAGE_KEY, false)

export const useApiDeprecationBanner = () => {
  const permissions = useUnit($userService.$permissions)
  const [wasDismissedBeforeMount] = useState<boolean>(() => Boolean(dismissedStorage.getItem()))
  const [isClosing, setIsClosing] = useState(false)

  const isBeforeDeadline = Date.now() < API_DEPRECATION_DEADLINE.getTime()
  const hasRequiredPermission = API_DEPRECATION_REQUIRED_PERMISSIONS.some((permission) => permissions.has(permission))

  const isVisible = isBeforeDeadline && hasRequiredPermission && !wasDismissedBeforeMount

  const handleClose = () => {
    setIsClosing(true)
    dismissedStorage.setItem(true)
  }

  return { isVisible, isClosing, handleClose }
}
